import { CarpentryOrder } from 'src/app/models/configurators-2d/applications/carpentry/carpentry-order';
import { QuotationRecord } from 'src/app/models/configurators-2d/applications/carpentry/quotation-record';

export function hasCarpentrySupplierSendingError(
  latestOrder: CarpentryOrder | undefined,
  record: QuotationRecord
): boolean {
  const hasOrderNumberOnOrder = latestOrder?.orderNumber != null;
  const hasOrderNumberOnRecord = typeof record.orderNumber === 'string' && record.orderNumber.trim().length > 0;
  const orderRefNumbers = latestOrder?.orderRefNumbers;
  const matchesPaidOrderNumbers =
    !orderRefNumbers?.length || orderRefNumbers.some(orderRefNumber => orderRefNumber.toString() === record.orderNumber);

  return hasOrderNumberOnOrder && hasOrderNumberOnRecord && matchesPaidOrderNumbers && !record.supplierSent;
}
